import { ContentPanel } from 'shared/styles/components';
import { ProductContainer } from './product.styles';
import { Product } from './product.types';

type ProductPageProps = {
  product: Product;
  children: React.ReactNode;
};

export default function ProductPage({ product, children }: ProductPageProps) {
  return (
    <>
      <ContentPanel>
        <ProductContainer>{children}</ProductContainer>
      </ContentPanel>
    </>
  );
}
